import { render, staticRenderFns } from "./ProjectMoreButton.vue?vue&type=template&id=507c8eb9"
import script from "./ProjectMoreButton.vue?vue&type=script&lang=js"
export * from "./ProjectMoreButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports